/** Test IDs for the admin dashboard + navigation (Task 7). */
export const NAV = {
        shell: 'admin-nav-shell',
        dashboardLink: 'nav-dashboard-link',
        municipalitiesLink: 'nav-municipalities-link',
        settingsLink: 'nav-settings-link',
        usersLink: 'nav-users-link',
        userMenu: 'nav-user-menu',
        roleBadge: 'nav-role-badge',
        mobileMenuButton: 'admin-mobile-menu-button',
        mobileDrawer: 'admin-mobile-drawer',
};

export const MUNI = {
        page: 'municipalities-page',
        searchInput: 'municipalities-search-input',
        createButton: 'municipality-create-button',
        dialog: 'municipality-form-dialog',
        nameInput: 'municipality-name-input',
        slugInput: 'municipality-slug-input',
        regionInput: 'municipality-region-input',
        provinceInput: 'municipality-province-input',
        descriptionInput: 'municipality-description-input',
        isPublicSwitch: 'municipality-is-public-switch',
        adminNameInput: 'municipality-admin-name-input',
        adminEmailInput: 'municipality-admin-email-input',
        submitButton: 'municipality-submit-button',
        configureButton: 'municipality-configure-button',
        secretDialog: 'municipality-secret-dialog',
        secretValue: 'municipality-secret-value',
        secretCloseButton: 'municipality-secret-close-button',
};

export const USERS = {
        page: 'users-page',
        loading: 'users-loading',
        table: 'users-table',
        row: 'users-row',
        searchInput: 'users-search-input',
        roleFilter: 'users-role-filter',
        statusFilter: 'users-status-filter',
        createButton: 'users-create-button',
        dialog: 'users-form-dialog',
        fullNameInput: 'users-fullname-input',
        emailInput: 'users-email-input',
        roleSelect: 'users-role-select',
        submitButton: 'users-submit-button',
        editButton: 'users-edit-button',
        suspendButton: 'users-suspend-button',
        reactivateButton: 'users-reactivate-button',
        resetButton: 'users-reset-button',
        secretDialog: 'users-secret-dialog',
        secretValue: 'users-secret-value',
        secretCloseButton: 'users-secret-close-button',
        localBusinessDisabledHint: 'users-local-business-disabled-hint',
        changePasswordDialog: 'change-password-dialog',
        currentPasswordInput: 'change-password-current-input',
        newPasswordInput: 'change-password-new-input',
        changePasswordSubmit: 'change-password-submit',
};

export const SETTINGS = {
        page: 'settings-page',
        loading: 'settings-loading',
        nameInput: 'settings-name-input',
        shortDescInput: 'settings-short-description-input',
        territoryInput: 'settings-territory-input',
        addressInput: 'settings-address-input',
        phoneInput: 'settings-phone-input',
        emailInput: 'settings-email-input',
        pecInput: 'settings-pec-input',
        websiteInput: 'settings-website-input',
        facebookInput: 'settings-facebook-input',
        instagramInput: 'settings-instagram-input',
        youtubeInput: 'settings-youtube-input',
        operatorsPublishSwitch: 'settings-operators-publish-switch',
        localBusinessSwitch: 'settings-local-business-switch',
        autoArchiveSwitch: 'settings-auto-archive-switch',
        privacyInput: 'settings-privacy-url-input',
        cookieInput: 'settings-cookie-url-input',
        legalInput: 'settings-legal-url-input',
        saveButton: 'settings-save-button',
};

export const DASH = {
        page: 'dashboard-page',
        welcome: 'dashboard-welcome',
        statEvents: 'dashboard-stat-events',
        createButton: 'dashboard-create-event-button',
        createDialog: 'dashboard-create-dialog',
        titleInput: 'dashboard-event-title-input',
        dateInput: 'dashboard-event-date-input',
        submitCreate: 'dashboard-event-submit',
        eventsList: 'dashboard-events-list',
        approveButton: 'dashboard-approve-button',
        publishButton: 'dashboard-publish-button',
        editButton: 'dashboard-edit-button',
        submitEdit: 'dashboard-event-edit-submit',
        municipalitiesSection: 'dashboard-municipalities-section',
        noPermHint: 'dashboard-no-perm-hint',
};
